export function getAddress() {
  return 'https://messenger.holding5040.ir/chat/download';
  // return 'http://192.168.121:199:5000/chat/download';
}
